/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_itemSearch" | "SbRespNullSearchResultsHeader_itemSearch" | "SbSharedNullSearchRelatedItems_itemSearch">;
    readonly " $refType": "SbRespNullSearchResults_itemSearch";
};
export type SbRespNullSearchResults_itemSearch$data = SbRespNullSearchResults_itemSearch;
export type SbRespNullSearchResults_itemSearch$key = {
    readonly " $data"?: SbRespNullSearchResults_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResults_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResultsHeader_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '15c1399118c7c75d957e93ac6aaca969';
export default node;
